import React from "react";
import { withPreview } from "./PreviewRoot"; // ★ Provider와 동일 파일/경로 사용!

class PreviewTrigger extends React.Component {
  handleEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();

    this.props.preview.open({
      rect,
      align: this.props.align || "right",
      slides: Array.isArray(this.props.slides) ? this.props.slides : undefined,
      data: this.props.previewData,
    });
  };

  handleLeave = (e) => {
    const rt = e.relatedTarget;
    const safe =
      rt && (rt.closest?.(".img-thumbnail") || rt.closest?.(".preview-box"));
    if (!safe) this.props.preview.close();
  };

  handlePointerEnter = (e) => {
    // PC 마우스에서는 기존 hover 방식 그대로 연다.
    if (e.pointerType && e.pointerType !== "mouse") return;
    this.handleEnter(e);
  };

  handlePointerLeave = (e) => {
    // 터치에서는 pointerleave로 프리뷰를 닫지 않는다.
    if (e.pointerType && e.pointerType !== "mouse") return;
    this.handleLeave(e);
  };

  handlePointerDown = (e) => {
    // 모바일/태블릿에서는 hover 이벤트에 의존하지 않고 터치 시 프리뷰를 연다.
    if (e.pointerType !== "touch" && e.pointerType !== "pen") return;

    const rect = e.currentTarget.getBoundingClientRect();
    this.props.preview.open({
      rect,
      align: this.props.align || "right",
      slides: Array.isArray(this.props.slides) ? this.props.slides : undefined,
      data: this.props.previewData,
    });
  };

  render() {
    return (
      <div
        // className="img-thumbnail"
        onPointerEnter={this.handlePointerEnter}
        onPointerLeave={this.handlePointerLeave}
        onPointerDown={this.handlePointerDown}
        style={{ display: "inline-block", touchAction: "manipulation" }}
      >
        {this.props.children}
      </div>
    );
  }
}

export default withPreview(PreviewTrigger);